import { render, staticRenderFns } from "./TripSidebarSection.vue?vue&type=template&id=b56b005c"
import script from "./TripSidebarSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TripSidebarSection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports